import React from 'react';
import { Box, Modal, Spinner } from '@usealloy/component-library';

type DataLoadingModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const DataLoadingModal: React.FC<DataLoadingModalProps> = ({
  isOpen,
  onClose,
}) => (
  <Modal
    header="Fetching Data"
    isOpen={isOpen}
    onClose={onClose}
    size="small"
    style={{
      minHeight: '220px',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      alignItems="center"
      justifyContent="center"
      style={{ padding: 'var(--cl-space-2)' }}
    >
      <Spinner />
    </Box>
  </Modal>
);
